import React from 'react'
import { Container, Row, Col } from 'react-awesome-styled-grid'

import Badge from '../components/Badge'
import Button from '../components/Button'
import CardIcon from '../components/CardIcon'
import Color from '../components/Color'
import { Section, SectionHeading, SectionContent } from '../components/Section'
import Text from '../components/Text'
import Title from '../components/Title'
// import { ModalContext } from '../hooks'
import details from '../mocks/details'

const About = () => {
  // const { setModalState } = useContext(ModalContext)

  return (
    <Section
      id="novos-modulos"
      bgImage="/images/bg-about.jpg"
      bgSize="55%"
      paddingTop={120}
      paddingBottom={60}
      fluid
    >
      <Container>
        <Row justify="space-between">
          <Col md={5} align="center">
            <SectionHeading className="t-center" marginBottom={24}>
              <Badge
                label="Novos módulos"
                marginBottom={32}
                data-sal="zoom-in"
                data-sal-delay="300"
                data-sal-easing="ease"
                data-sal-duration="800"
              />
              <Title
                appearance="hero-tiny"
                size={24}
                color="primary"
                className="t-center"
                afterTitle="aprenda a<br /> Costela no Bafo com Xerém"
                data-sal="zoom-in"
                data-sal-delay="400"
                data-sal-easing="ease"
                data-sal-duration="800"
              >
                Milho e Macaxeira
              </Title>
            </SectionHeading>
          </Col>
          <Col md={6} style={{ position: 'relative' }}>
            <SectionContent>
              <Row>
                <Col md={12} className="t-center-mobile">
                  <Text
                    marginBottom={16}
                    size={18}
                    data-sal="slide-right"
                    data-sal-delay="500"
                    data-sal-easing="ease"
                    data-sal-duration="800"
                  >
                    <Color name="primary">•</Color> Pratos autorais produzidos
                    do início ao fim para você aprender.
                  </Text>
                  <Text
                    marginBottom={16}
                    size={18}
                    data-sal="slide-right"
                    data-sal-delay="600"
                    data-sal-easing="ease"
                    data-sal-duration="800"
                  >
                    <Color name="primary">•</Color> Técnicas para a criação das
                    suas próprias receitas.
                  </Text>
                  <Text
                    marginBottom={16}
                    size={18}
                    data-sal="slide-right"
                    data-sal-delay="700"
                    data-sal-easing="ease"
                    data-sal-duration="800"
                  >
                    <Color name="primary">•</Color> Passo a passo detalhado e
                    adequado para qualquer nível de familiaridade com a cozinha.
                  </Text>
                  <Text
                    marginBottom={16}
                    size={18}
                    data-sal="slide-right"
                    data-sal-delay="800"
                    data-sal-easing="ease"
                    data-sal-duration="800"
                  >
                    <Color name="primary">•</Color> Utilize os alimentos de
                    maior importância da região, em técnicas e preparos que
                    exploram todo o seu potencial de sabor.
                  </Text>
                </Col>

                {details.map(({ icon, title, afterTitle, action }, i) => (
                  <Col md={4} key={i}>
                    <CardIcon
                      icon={icon}
                      title={title}
                      afterTitle={afterTitle}
                      action={action}
                      marginBottom={32}
                      data-sal="zoom-in"
                      data-sal-delay={900}
                      data-sal-easing="ease"
                      data-sal-duration="800"
                    />
                  </Col>
                ))}

                <Col md={12} align="center" className="t-center">
                  <Text
                    marginTop={16}
                    marginBottom={16}
                    appearance="info"
                    data-sal="slide-up"
                    data-sal-delay="900"
                    data-sal-easing="ease"
                    data-sal-duration="800"
                    color="primary"
                  >
                    Em 10x nos cartões
                  </Text>

                  <Button
                    target="_blank"
                    href="https://pay.hotmart.com/N37277066I?checkoutMode=0&bid=1593475180852"
                    title="Quero comprar"
                    color="primary"
                    solid
                    xl
                    data-sal="slide-up"
                    data-sal-delay="1000"
                    data-sal-easing="ease"
                    data-sal-duration="800"
                  >
                    Quero comprar
                  </Button>

                  <Text
                    marginTop={16}
                    marginBottom={16}
                    size={12}
                    color="dark"
                    appearance="tag"
                    className="t-center"
                    data-sal="slide-down"
                    data-sal-delay="1000"
                    data-sal-easing="ease"
                    data-sal-duration="800"
                  >
                    Módulo Milho + Módulo Macaxeira
                  </Text>
                </Col>
              </Row>
            </SectionContent>
          </Col>
        </Row>
      </Container>
    </Section>
  )
}

export default About
